/* ============================================================
   PULSE THEME — theme.js  (vanilla, bağımlılıksız)
   Shopify AJAX Cart API ile çalışır.
============================================================ */
(function () {
  'use strict';
  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};
  var settings = (window.theme && window.theme.settings) || {};

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString(document.documentElement.lang || 'nl-NL', { minimumFractionDigits: 2 });
    var fmt = settings.moneyFormat || '{{amount}} TL';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{.*?\}\}/g, value);
  }

  // EU beden gösterimi: mini sepette, üründe bir "EU Beden" seçeneği varsa TR beden segmentini gizler
  function euCartLineVariantTitle(it) {
    if (!settings.enableEuSizeDisplay || !it.options_with_values || !it.options_with_values.length) {
      return it.variant_title;
    }
    var euNames = (settings.euSizeOptionNames || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var hiddenNames = (settings.hiddenSizeOptionNames || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    function matches(name, list) { return list.some(function (n) { return n && name.indexOf(n) > -1; }); }
    var hasEuOption = it.options_with_values.some(function (o) { return matches((o.name || '').toLowerCase(), euNames); });
    if (!hasEuOption) return it.variant_title;
    return it.options_with_values.filter(function (o) {
      var n = (o.name || '').toLowerCase();
      var isEu = matches(n, euNames);
      var isHidden = !isEu && matches(n, hiddenNames);
      return !isHidden;
    }).map(function (o) { return o.value; }).join(' / ');
  }

  function syncOptionAvailability(form, variants, chosen) {
    $$('[data-option-index]', form).forEach(function (input) {
      var idx = input.getAttribute('data-option-index');
      var value = input.value;
      var available = variants.some(function (v) {
        if (!v.available || v.options[idx] !== value) return false;
        return Object.keys(chosen).every(function (k) { return k === idx || v.options[k] === chosen[k]; });
      });
      var label = input.closest('.swatch');
      if (label) label.classList.toggle('is-unavailable', !available);
    });
  }

  /* ---------------- Sticky header gölgesi ---------------- */
  var header = $('#site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ---------------- Açma/kapama yardımcıları ---------------- */
  var overlay = $('#drawer-overlay');
  function openEl(el) { if (el) { el.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeAll() {
    $$('.cart-drawer,.mobile-menu').forEach(function (e) { e.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); closeSearch(); closeFacets(); closeLightbox(); }
    if (productLightbox && productLightbox.classList.contains('is-open')) {
      if (e.key === 'ArrowLeft') setLightboxImage(activeImageIndex - 1);
      if (e.key === 'ArrowRight') setLightboxImage(activeImageIndex + 1);
    }
  });
  $$('[data-close-drawer]').forEach(function (b) { b.addEventListener('click', closeAll); });

  /* ---------------- Mobil menü ---------------- */
  var burger = $('#burger'), mobileMenu = $('#mobile-menu');
  if (burger) burger.addEventListener('click', function () { openEl(mobileMenu); });
  $$('.mobile-menu__item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      $$('.mobile-menu__item', mobileMenu || document).forEach(function (other) {
        if (other !== item) other.removeAttribute('open');
      });
    });
  });

  /* ---------------- Arama overlay ---------------- */
  var searchOverlay = $('#search-overlay');
  function closeSearch() { if (searchOverlay) searchOverlay.classList.remove('is-open'); }
  var searchBtn = $('#search-toggle');
  if (searchBtn) searchBtn.addEventListener('click', function () {
    searchOverlay.classList.add('is-open');
    var inp = $('input[type="search"]', searchOverlay); if (inp) inp.focus();
  });
  $$('[data-close-search]').forEach(function (b) { b.addEventListener('click', closeSearch); });
  $$('[data-predictive-input]').forEach(function (input) {
    var box = $('[data-predictive-results]', input.form); var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer); var q = input.value.trim(); if (!box || q.length < 2) { if (box) box.innerHTML = ''; return; }
      timer = setTimeout(function () { fetch(routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4').then(function (r) { return r.json(); }).then(function (data) { var products = (((data || {}).resources || {}).results || {}).products || []; box.innerHTML = products.map(function (p) { var img = p.image || ''; return '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '<span>' + esc(p.title) + '</span></a>'; }).join(''); }).catch(function () { box.innerHTML = ''; }); }, 180);
    });
  });

  /* ---------------- Duyuru rotasyonu ---------------- */
  $$('.announcement[data-rotate]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------------- Slideshow ---------------- */
  $$('[data-slideshow]').forEach(function (root) {
    var slides = $$('.slideshow__slide', root);
    if (!slides.length) return;
    var dotsWrap = $('.slideshow__dots', root);
    var cur = 0, timer;
    var auto = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    slides.forEach(function (_, idx) {
      if (!dotsWrap) return;
      var b = document.createElement('button');
      b.setAttribute('aria-label', 'Slide ' + (idx + 1));
      if (idx === 0) b.classList.add('is-active');
      b.addEventListener('click', function () { go(idx); });
      dotsWrap.appendChild(b);
    });
    var dots = dotsWrap ? $$('button', dotsWrap) : [];
    function go(n) {
      slides[cur].classList.remove('is-active'); if (dots[cur]) dots[cur].classList.remove('is-active');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('is-active'); if (dots[cur]) dots[cur].classList.add('is-active');
      restart();
    }
    function restart() { if (!auto) return; clearInterval(timer); timer = setInterval(function () { go(cur + 1); }, auto); }
    var nx = $('.slideshow__arrow--next', root), pv = $('.slideshow__arrow--prev', root);
    if (nx) nx.addEventListener('click', function () { go(cur + 1); });
    if (pv) pv.addEventListener('click', function () { go(cur - 1); });
    restart();
  });

  /* ---------------- Accordion ---------------- */
  $$('.accordion__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      var open = panel.style.maxHeight && panel.style.maxHeight !== '0px';
      panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
      btn.classList.toggle('is-open', !open);
    });
  });

  /* ---------------- Ürün galeri + lightbox ---------------- */
  var productLightbox = $('[data-product-lightbox]');
  var lightboxImg = $('[data-lightbox-image]', productLightbox || document);
  var activeGallery = null;
  var activeImages = [];
  var activeImageIndex = 0;

  function setLightboxImage(index) {
    if (!activeImages.length || !lightboxImg) return;
    activeImageIndex = (index + activeImages.length) % activeImages.length;
    var item = activeImages[activeImageIndex];
    lightboxImg.classList.remove('is-loaded');
    window.setTimeout(function () {
      lightboxImg.src = item.src;
      lightboxImg.alt = item.alt || '';
      if (lightboxImg.complete) lightboxImg.classList.add('is-loaded');
    }, 80);
  }
  function openLightbox(gallery, index) {
    if (!productLightbox || !gallery) return;
    activeGallery = gallery;
    activeImages = gallery._images || [];
    if (!activeImages.length) return;
    setLightboxImage(index || 0);
    productLightbox.classList.add('is-open');
    productLightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!productLightbox) return;
    productLightbox.classList.remove('is-open');
    productLightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (lightboxImg) lightboxImg.addEventListener('load', function () { lightboxImg.classList.add('is-loaded'); });
  $$('[data-lightbox-close]').forEach(function (b) { b.addEventListener('click', closeLightbox); });
  $$('[data-lightbox-prev]').forEach(function (b) { b.addEventListener('click', function () { setLightboxImage(activeImageIndex - 1); }); });
  $$('[data-lightbox-next]').forEach(function (b) { b.addEventListener('click', function () { setLightboxImage(activeImageIndex + 1); }); });

  $$('[data-gallery]').forEach(bindGallery);

  function bindGallery(g) {
    if (!g || g._galleryBound) return;
    g._galleryBound = true;
    var main = $('[data-gallery-main]', g);
    var thumbs = $$('[data-gallery-thumb]', g);
    var dots = $$('[data-gallery-dot]', g);
    var items = thumbs.map(function (t) {
      return {
        src: t.getAttribute('data-full'),
        alt: t.getAttribute('data-alt') || '',
        srcset: t.getAttribute('data-srcset') || '',
        sizes: t.getAttribute('data-sizes') || (main && main.getAttribute('sizes')) || '(max-width: 990px) 100vw, 58vw'
      };
    }).filter(function (x) { return !!x.src; });
    if (!items.length && main) items.push({ src: main.currentSrc || main.src, alt: main.alt || '', srcset: main.getAttribute('srcset') || '', sizes: main.getAttribute('sizes') || '(max-width: 990px) 100vw, 58vw' });
    g._images = items;

    function preloadGalleryItem(item) {
      if (!item || item._preloading || item._preloaded) return;
      item._preloading = true;
      var img = new Image();
      img.decoding = 'async';
      if (item.srcset) {
        img.srcset = item.srcset;
        img.sizes = item.sizes || '(max-width: 990px) 100vw, 58vw';
      }
      img.onload = img.onerror = function () { item._preloaded = true; };
      img.src = item.src;
      item._preloader = img;
    }

    function scheduleGalleryPreload() {
      var run = function () {
        items.forEach(function (item, idx) {
          if (idx === 0) return;
          window.setTimeout(function () { preloadGalleryItem(item); }, idx * 120);
        });
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1600 });
      } else {
        window.setTimeout(run, 700);
      }
    }

    function setGallery(index) {
      if (!main || !items.length) return;
      index = (index + items.length) % items.length;
      var item = items[index];
      preloadGalleryItem(item);
      main.classList.add('is-changing');
      window.setTimeout(function () {
        if (item.srcset) {
          main.setAttribute('srcset', item.srcset);
          main.setAttribute('sizes', item.sizes || '(max-width: 990px) 100vw, 58vw');
        } else {
          main.removeAttribute('srcset');
        }
        main.src = item.src;
        main.alt = item.alt || main.alt;
        main.setAttribute('data-gallery-index', String(index));
        main.classList.remove('is-changing');
      }, item._preloaded ? 30 : 80);
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-index') == index); });
      dots.forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-index') == index); });
    }
    thumbs.forEach(function (t) {
      var idx = parseInt(t.getAttribute('data-index') || 0, 10);
      var warm = function () { preloadGalleryItem(items[idx]); };
      t.addEventListener('pointerenter', warm, { passive: true });
      t.addEventListener('touchstart', warm, { passive: true });
      t.addEventListener('click', function () { setGallery(idx); });
    });
    dots.forEach(function (d) {
      var idx = parseInt(d.getAttribute('data-index') || 0, 10);
      d.addEventListener('pointerenter', function () { preloadGalleryItem(items[idx]); }, { passive: true });
      d.addEventListener('click', function () { setGallery(idx); });
    });
    scheduleGalleryPreload();
    $$('[data-gallery-open]', g).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = main ? parseInt(main.getAttribute('data-gallery-index') || 0, 10) : 0;
        openLightbox(g, idx);
      });
    });
    var mainWrap = $('[data-gallery-main-wrap]', g);
    if (mainWrap) {
      var startX = 0, startY = 0, startTime = 0;
      mainWrap.addEventListener('touchstart', function (e) {
        if (!items.length || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTime = Date.now();
      }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (!items.length || !startX || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        var fastEnough = Date.now() - startTime < 700;
        startX = 0;
        if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) || !fastEnough) return;
        var current = main ? parseInt(main.getAttribute('data-gallery-index') || 0, 10) : 0;
        setGallery(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }
  }

  /* ---------------- Ürün varyant seçimi ---------------- */
  $$('[data-product-form]').forEach(function (form) {
    var data = form.getAttribute('data-variants');
    if (!data) return;
    var variants = JSON.parse(data);
    var idField = $('[name="id"]', form);
    var scope = form.closest('.product__details') || form.closest('.quickview__body') || form;
    var priceEl = $('[data-product-price]', scope);
    var addBtn = $('[data-add-btn]', form);
    function selectedOptions() {
      return $$('[data-option-index]', form).filter(function (el) {
        return el.type === 'radio' ? el.checked : true;
      }).map(function (el) { return el.value; });
    }
    function update() {
      var chosen = {};
      $$('[data-option-index]', form).forEach(function (el) {
        if (el.type === 'radio' && !el.checked) return;
        chosen[el.getAttribute('data-option-index')] = el.value;
      });
      syncOptionAvailability(form, variants, chosen);
      var match = variants.find(function (v) {
        return Object.keys(chosen).every(function (k) { return v.options[k] === chosen[k]; });
      });
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.innerHTML = formatMoney(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? strings.addToCart : strings.soldOut;
      }
    }
    form.addEventListener('change', update);
    update();
  });

  /* ---------------- Sepete ekle (AJAX) ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    if (settings.cartType !== 'drawer') return; // sayfa modunda normal submit
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '...'; }
    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(serialize(form))
    }).then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openCart(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || strings.addToCart; } });
  });

  // Quick-add butonları (kart üstü)
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    var id = qa.getAttribute('data-quick-add');
    qa.disabled = true;
    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(openCart)
      .finally(function () { qa.disabled = false; });
  });

  // Hızlı satın al (quick view içinde) — sepete ekleyip checkout'a yönlendir
  document.addEventListener('click', function (e) {
    var qb = e.target.closest('[data-quickbuy]');
    if (!qb) return;
    e.preventDefault();
    var form = qb.closest('form[action$="/cart/add"]');
    if (!form) return;
    qb.disabled = true;
    qb.dataset.label = qb.textContent;
    qb.textContent = '...';
    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(serialize(form))
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = (routes.root_url || '/').replace(/\/$/, '') + '/checkout';
    }).catch(function () {
      qb.disabled = false;
      qb.textContent = qb.dataset.label || (strings.buyNow || 'Buy now');
    });
  });

  function serialize(form) {
    var fd = new FormData(form);
    var items = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || 1, 10) }] };
    var props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/properties\[(.+)\]/);
      if (m) props[m[1]] = v;
    });
    if (Object.keys(props).length) items.items[0].properties = props;
    return items;
  }

  /* ---------------- Sepet drawer ---------------- */
  var cartDrawer = $('#cart-drawer');
  var cartBtn = $('#cart-toggle');
  if (cartBtn && settings.cartType === 'drawer') {
    cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  }
  function openCart() { refreshCart().then(function () { openEl(cartDrawer); }); }

  function refreshCart() {
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function renderCart(cart) {
    var body = $('#cart-drawer-body');
    var countEls = $$('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    if (!body) return cart;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-empty">' + strings.cartEmpty + '</p>';
    } else {
      var html = '';
      // Ücretsiz kargo barı
      var threshold = settings.freeShipThreshold || 0;
      if (threshold > 0) {
        var remain = threshold - cart.total_price;
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        html += '<div class="cart-progress">';
        html += remain > 0
          ? '<span>' + (strings.freeShipProgress || 'Nog {{ amount }} tot gratis verzending!').replace('{{ amount }}', '<strong>' + formatMoney(remain) + '</strong>') + '</span>'
          : '<span>' + strings.freeShipReached + '</span>';
        html += '<div class="cart-progress__bar"><div class="cart-progress__fill" style="width:' + pct + '%"></div></div></div>';
      }
      cart.items.forEach(function (it, idx) {
        html += '<div class="cart-line" data-key="' + it.key + '">'
          + '<img src="' + (it.image ? it.image.replace(/(\.[^.]*)$/, '_120x$1') : '') + '" alt="">'
          + '<div style="flex:1">'
          + '<div class="cart-line__title">' + it.product_title + '</div>'
          + (it.variant_title ? '<div class="cart-line__variant">' + euCartLineVariantTitle(it) + '</div>' : '')
          + '<div class="cart-line__price">' + formatMoney(it.final_line_price) + '</div>'
          + '<div class="qty">'
          + '<button data-qty-dec="' + (idx + 1) + '">−</button>'
          + '<input type="text" value="' + it.quantity + '" data-qty-input="' + (idx + 1) + '" readonly>'
          + '<button data-qty-inc="' + (idx + 1) + '">+</button>'
          + '</div></div>'
          + '<button class="cart-line__remove" data-qty-remove="' + (idx + 1) + '">×</button>'
          + '</div>';
      });
      body.innerHTML = html;
    }
    var sub = $('[data-cart-subtotal]');
    if (sub) sub.innerHTML = formatMoney(cart.total_price);
    return cart;
  }

  // Drawer içi adet değişimi
  document.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-qty-inc]');
    var dec = e.target.closest('[data-qty-dec]');
    var rm = e.target.closest('[data-qty-remove]');
    var line, qty;
    if (inc) { line = inc.getAttribute('data-qty-inc'); qty = +$('[data-qty-input="' + line + '"]').value + 1; }
    else if (dec) { line = dec.getAttribute('data-qty-dec'); qty = Math.max(0, +$('[data-qty-input="' + line + '"]').value - 1); }
    else if (rm) { line = rm.getAttribute('data-qty-remove'); qty = 0; }
    else return;
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  /* ---------------- Newsletter (Shopify contact form) ---------------- */
  $$('[data-newsletter]').forEach(function (form) {
    if (window.location.search.indexOf('customer_posted=true') > -1) {
      var ok = $('.newsletter__success', form.parentNode);
      if (ok) ok.hidden = false;
    }
  });

  /* ---------------- Carousel (yatay ürün şeridi) ---------------- */
  $$('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    function step() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 28, 10) || 28;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  });

  /* ---------------- Mobile collection facets ---------------- */
  var facetsPanel = $('[data-facets-panel]');
  var facetsBackdrop = $('.facets-backdrop');
  function openFacets() { if (facetsPanel) facetsPanel.classList.add('is-open'); if (facetsBackdrop) facetsBackdrop.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeFacets() { if (facetsPanel) facetsPanel.classList.remove('is-open'); if (facetsBackdrop) facetsBackdrop.classList.remove('is-open'); document.body.style.overflow = ''; }
  $$('[data-facets-toggle]').forEach(function (b) { b.addEventListener('click', openFacets); });
  $$('[data-facets-close]').forEach(function (b) { b.addEventListener('click', closeFacets); });

  /* ---------------- Infinite scroll (lazy load) ---------------- */
  (function () {
    var grid = $('[data-infinite-grid]');
    var status = $('[data-infinite-status]');
    if (!grid || !status) return;
    var loading = false;
    var finished = false;

    function loadNext() {
      if (loading || finished) return;
      var nextLink = $('[data-infinite-next]', status);
      if (!nextLink) { finished = true; if (observer) observer.disconnect(); return; }
      var url = nextLink.getAttribute('href');
      if (!url) { finished = true; return; }
      loading = true;
      var spinner = $('[data-infinite-spinner]', status);
      if (spinner) spinner.hidden = false;
      nextLink.style.display = 'none';
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-infinite-grid]');
          if (newGrid) {
            var frag = document.createDocumentFragment();
            Array.prototype.slice.call(newGrid.children).forEach(function (node) { frag.appendChild(node); });
            grid.appendChild(frag);
          }
          var newStatus = doc.querySelector('[data-infinite-status]');
          var newNext = newStatus ? newStatus.querySelector('[data-infinite-next]') : null;
          if (newNext) {
            nextLink.setAttribute('href', newNext.getAttribute('href'));
            nextLink.style.display = '';
          } else {
            finished = true;
            if (observer) observer.disconnect();
            status.parentNode && status.parentNode.removeChild(status);
          }
        })
        .catch(function () {
          // Hata olursa kullanıcı manuel devam edebilsin
          nextLink.style.display = '';
        })
        .finally(function () {
          loading = false;
          if (spinner) spinner.hidden = true;
        });
    }

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) loadNext(); });
      }, { rootMargin: '600px 0px' });
      observer.observe(status);
    }
    // Manuel tıklama da çalışsın (JS engelliyse de link sayfaya gider)
    status.addEventListener('click', function (e) {
      var link = e.target.closest('[data-infinite-next]');
      if (!link) return;
      e.preventDefault();
      loadNext();
    });
  })();

  /* ---------------- Impulse parity: recommendations, recently viewed, countdown, popups ---------------- */
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  if (window.customElements && !customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() { var url = this.dataset.url; if (!url) return; fetch(url).then(function (r) { return r.text(); }).then((txt) => { var doc = new DOMParser().parseFromString(txt, 'text/html'); var el = doc.querySelector('product-recommendations'); if (el && el.innerHTML.trim()) this.innerHTML = el.innerHTML; }); }
    });
  }
  var curProductScript = $('[data-current-product-card]');
  if (curProductScript) { try { var curP = JSON.parse(curProductScript.textContent); var rv = JSON.parse(localStorage.getItem('pulse_recently') || '[]').filter(function (p) { return p.id !== curP.id; }); rv.unshift(curP); localStorage.setItem('pulse_recently', JSON.stringify(rv.slice(0, 12))); } catch (e) {} }
  $$('[data-recently-viewed]').forEach(function (root) { var limit = parseInt(root.dataset.limit || 4, 10); var curId = curProductScript ? JSON.parse(curProductScript.textContent).id : null; var items = JSON.parse(localStorage.getItem('pulse_recently') || '[]').filter(function (p) { return p.id !== curId; }).slice(0, limit); if (!items.length) { var sec = root.closest('[data-recently-viewed-section]'); if (sec) sec.hidden = true; return; } root.innerHTML = items.map(function (p) { return '<div class="card"><a class="card__media card__media--portrait" href="' + esc(p.url) + '"><img class="card__img-front" src="' + esc(p.image) + '" alt="' + esc(p.imageAlt || p.title) + '" loading="lazy"></a><div class="card__info"><h3 class="card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3><div class="card__price">' + esc(p.price) + '</div></div></div>'; }).join(''); });
  $$('[data-countdown-end]').forEach(function (el) { var end = new Date(el.dataset.countdownEnd).getTime(); if (!end) return; function tick() { var diff = Math.max(0, end - Date.now()); var d = Math.floor(diff / 86400000), h = Math.floor(diff / 3600000) % 24, m = Math.floor(diff / 60000) % 60, s = Math.floor(diff / 1000) % 60; $('[data-days]', el).textContent = String(d).padStart(2, '0'); $('[data-hours]', el).textContent = String(h).padStart(2, '0'); $('[data-minutes]', el).textContent = String(m).padStart(2, '0'); $('[data-seconds]', el).textContent = String(s).padStart(2, '0'); } tick(); setInterval(tick, 1000); });
  $$('[data-before-after]').forEach(function (wrap) { var input = $('input[type="range"]', wrap); if (input) input.addEventListener('input', function () { wrap.style.setProperty('--pos', input.value + '%'); }); });
  var age = $('[data-age-verifier]'); if (age && localStorage.getItem('pulse_age_ok') !== '1') age.hidden = false; $$('[data-age-accept]').forEach(function (b) { b.addEventListener('click', function () { localStorage.setItem('pulse_age_ok', '1'); if (age) age.hidden = true; }); }); $$('[data-age-decline]').forEach(function (b) { b.addEventListener('click', function () { history.back(); }); });
  var popup = $('[data-promo-popup]'); if (popup && sessionStorage.getItem('pulse_popup_closed') !== '1') setTimeout(function () { popup.hidden = false; }, 1400); $$('[data-promo-close]').forEach(function (b) { b.addEventListener('click', function () { sessionStorage.setItem('pulse_popup_closed', '1'); if (popup) popup.hidden = true; }); });

  // İlk yükte sepet sayacını senkronla
  if (settings.cartType === 'drawer') refreshCart();

  /* ---------------- Hızlı bakış (Quick View) ---------------- */
  var qvOverlay = $('#quickview-overlay');
  var qvContent = $('#quickview-content');
  function closeQuick() { if (qvOverlay) qvOverlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  if (qvOverlay) {
    qvOverlay.addEventListener('click', function (e) { if (e.target === qvOverlay) closeQuick(); });
    $$('[data-close-quickview]').forEach(function (b) { b.addEventListener('click', closeQuick); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuick(); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quickview]');
    if (!btn || !qvOverlay) return;
    e.preventDefault();
    var url = btn.getAttribute('data-quickview');
    qvContent.innerHTML = '<div class="quickview__loading">…</div>';
    qvOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=quickview')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        qvContent.innerHTML = html;
        // Yeni eklenen forma varyant mantığını bağla
        bindVariantForm(qvContent.querySelector('[data-product-form]'));
        // Quick view galerisini bağla (thumbnail + dots + mobil kaydırma)
        var qvGallery = qvContent.querySelector('[data-gallery]');
        if (qvGallery) bindGallery(qvGallery);
      })
      .catch(function () { qvContent.innerHTML = '<div class="quickview__loading">Yüklenemedi.</div>'; });
  });

  // Varyant formu bağlama (quick view içinde dinamik form için)
  function bindVariantForm(form) {
    if (!form) return;
    var data = form.getAttribute('data-variants');
    if (!data) return;
    var variants = JSON.parse(data);
    var idField = form.querySelector('[name="id"]');
    var scope = form.closest('.product__details') || form.closest('.quickview__body') || form;
    var priceEl = scope.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-btn]');
    function update() {
      var chosen = {};
      $$('[data-option-index]', form).forEach(function (el) {
        if (el.type === 'radio' && !el.checked) return;
        chosen[el.getAttribute('data-option-index')] = el.value;
      });
      syncOptionAvailability(form, variants, chosen);
      var match = variants.find(function (v) {
        return Object.keys(chosen).every(function (k) { return v.options[k] === chosen[k]; });
      });
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.innerHTML = formatMoney(match.price);
      if (addBtn) { addBtn.disabled = !match.available; addBtn.textContent = match.available ? strings.addToCart : strings.soldOut; }
    }
    form.addEventListener('change', update);
    update();
  }
})();
